import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=8f663884&scoped=true"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"
import style0 from "./Customers.vue?vue&type=style&index=0&id=8f663884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f663884",
  null
  
)

export default component.exports